import React from 'react';
import TrendingBarContainer from './views/trending-bar-container';

function TrendingBarHomePage() {
  return (
    <TrendingBarContainer />
  );
}

export default TrendingBarHomePage;
